import React from "react";
import Nav from "react-bootstrap/Nav";
import config from "../../../config";

const DesignerMenuItem = ({url, menu_item, designer, classname, show_designers_menu}) => {
    return (
        <Nav.Item
            className={`${classname} nav-link nav-top-link`}
            as="a"
            href={show_designers_menu ? `${url}${encodeURIComponent(designer.slug)}?sort=created-descending&_=pf` : `${url}&${menu_item.other_filter_key}=${encodeURIComponent(designer.name)}`}
        >
            {designer.is_new === true && <span className="top-nav__new-label">New</span>}
            {designer.name}
        </Nav.Item>
    );
}

export default DesignerMenuItem;